export default __webpack_public_path__ + "files/FP4_Create_your_good_financial_schemes_in_your_region.docx";